import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProfile } from '../../services/authApi';
import { loginSuccess, logout, setLoading } from '../reducers/auth';

// ==============================|| AUTH THUNKS ||============================== //

/**
 * initializeAuth — called once on app boot (App.js useEffect)
 *
 * Strategy: attempt GET /auth/profile with the httpOnly cookie.
 *   - If it succeeds  → admin has a valid session → populate Redux with user data
 *   - If it fails 401 → no valid cookie / session expired → stay logged out
 *
 * This replaces the old localStorage token hydration approach.
 */
export const initializeAuth = createAsyncThunk(
  'auth/initialize',
  async (_, { dispatch }) => {
    try {
      const response = await getProfile();
      // response.data contains the user profile from the server
      const user = response.data;
      if (user) {
        dispatch(loginSuccess({ user }));
      } else {
        dispatch(logout());
      }
    } catch (error) {
      // 401 = no valid cookie/session → not logged in (expected, not an error)
      dispatch(logout());
    } finally {
      dispatch(setLoading(false));
    }
  }
);